import { APIResponse } from '../models/api-response.model';
import { APIServiceService } from './apiservice.service';
import { Observable, observable } from 'rxjs';
import { AppointmentAPIBody } from '../models/appointment-api-body.model';

export class AppointmentsEndpoint {
  endpoint = 'appointments/';
  cachedTypes
  constructor(private apiService: APIServiceService) {}



  async create(appointmentBody: AppointmentAPIBody): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint, token, appointmentBody).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async patch(appointmentID: number, detailsToUpdate: any): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint + 'patch/' + appointmentID, token, detailsToUpdate).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }

  async confirm(appointmentID: number): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint + `/${appointmentID}/confirm/`, token, {}).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async delete(appointmentId: any): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doDELETE(this.endpoint + appointmentId, token).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getByID(appointmentId: number, includes?: string[]): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + appointmentId, token, {include: includes}).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getProvisional(appointmentHashedId: string): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentApptDetailsToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint + '/provisional/' + appointmentHashedId, token, {}).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getWithinDates(startDate: string, endDate: string, splitByDate: boolean): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doGET(this.endpoint, token, { startDate, endDate, splitByDate }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async getTypes(): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }

      if(this.cachedTypes){
        return this.cachedTypes
      }

      const response = await this.apiService.doGET(this.endpoint + "types", token, {}).toPromise();
      this.cachedTypes = response
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async updateStartEndTimes(appointmentId: number, startTime: string, endTime: string): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST(this.endpoint + '/patch/' + appointmentId, token, { startTime, endTime }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async requestAccessSMSForBookingID(appointmentId: string): Promise<APIResponse> {
    try {
      const response = await this.apiService.doPOST(this.endpoint + '/access/sms/', "", { appointmentId }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async confirmAccessSMSForBookingID(appointmentId: string, code: string): Promise<APIResponse> {
    try {
      const response = await this.apiService.doPOST(this.endpoint + '/access/sms/confirm', "", { appointmentId, code }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  






}
